import { render, staticRenderFns } from "./EModalBnccFranquia.vue?vue&type=template&id=40ccaffb&scoped=true"
import script from "./EModalBnccFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBnccFranquia.vue?vue&type=script&lang=js"
import style0 from "./EModalBnccFranquia.vue?vue&type=style&index=0&id=40ccaffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccaffb",
  null
  
)

export default component.exports